(function (window, document) {
    "use strict";

    var galleryStates = new WeakMap();

    function normalizeVideo(video) {
        video.autoplay = false;
        video.removeAttribute("autoplay");
        video.preload = "none";
        video.setAttribute("preload", "none");
        video.playsInline = true;
        video.setAttribute("playsinline", "");
        video.muted = true;
        if (window.MarlotVideoPlaybackCoordinator) {
            window.MarlotVideoPlaybackCoordinator.register(video);
        }
    }

    function bindSwiper(state, swiper) {
        if (!swiper || typeof swiper.on !== "function" || state.swiper === swiper) return;

        state.swiper = swiper;
        ["activeIndexChange", "transitionEnd", "touchEnd", "scroll"].forEach(function (eventName) {
            swiper.on(eventName, state.sync);
        });
    }

    function init(gallery, swiper) {
        if (typeof gallery === "string") {
            gallery = document.querySelector(gallery);
        }
        if (!gallery) return null;

        var videos = Array.prototype.slice.call(gallery.querySelectorAll("video"));
        videos.forEach(normalizeVideo);

        var existingState = galleryStates.get(gallery);
        if (existingState) {
            existingState.videos = videos;
            bindSwiper(existingState, swiper);
            existingState.sync();
            return existingState;
        }

        var mobileViewport = typeof window.matchMedia === "function"
            ? window.matchMedia("(max-width: 640px)")
            : { matches: false };
        var reducedMotion = typeof window.matchMedia === "function"
            ? window.matchMedia("(prefers-reduced-motion: reduce)")
            : { matches: false };
        var connection = window.navigator && (
            window.navigator.connection ||
            window.navigator.mozConnection ||
            window.navigator.webkitConnection
        );

        var state = {
            gallery: gallery,
            videos: videos,
            swiper: null,
            inViewport: false,
            mobileViewport: mobileViewport,
            reducedMotion: reducedMotion,
            connection: connection,
            sync: null
        };

        function constrainedPlayback() {
            return state.mobileViewport.matches ||
                state.reducedMotion.matches ||
                Boolean(state.connection && state.connection.saveData);
        }

        function activeVideo() {
            var activeSlide = null;

            if (state.swiper && state.swiper.slides) {
                activeSlide = state.swiper.slides[state.swiper.activeIndex];
            }
            if (!activeSlide) {
                activeSlide = gallery.querySelector(".swiper-slide-active");
            }

            return activeSlide ? activeSlide.querySelector("video") : null;
        }

        state.sync = function () {
            var target = null;
            var canPlay = state.inViewport && !document.hidden && !constrainedPlayback();

            if (canPlay) {
                target = activeVideo();
            }

            state.videos.forEach(function (video) {
                if (video !== target) {
                    video.pause();
                    return;
                }

                if (video.paused) {
                    if (window.MarlotVideoPlaybackCoordinator) {
                        window.MarlotVideoPlaybackCoordinator.requestPlay(video);
                    }
                }
            });
        };

        galleryStates.set(gallery, state);
        bindSwiper(state, swiper);

        if ("IntersectionObserver" in window) {
            state.observer = new window.IntersectionObserver(function (entries) {
                var entry = entries[0];
                state.inViewport = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
                state.sync();
            }, { threshold: [0, 0.01, 0.5] });
            state.observer.observe(gallery);
        } else {
            state.inViewport = true;
        }

        document.addEventListener("visibilitychange", state.sync);

        [mobileViewport, reducedMotion].forEach(function (mediaQuery) {
            if (typeof mediaQuery.addEventListener === "function") {
                mediaQuery.addEventListener("change", state.sync);
            } else if (typeof mediaQuery.addListener === "function") {
                mediaQuery.addListener(state.sync);
            }
        });

        if (connection && typeof connection.addEventListener === "function") {
            connection.addEventListener("change", state.sync);
        }

        state.sync();
        return state;
    }

    window.MarlotProductGalleryVideo = {
        init: init
    };
})(window, document);
